import './set-public-path'; // MUST be the first import — sets __webpack_public_path__ at runtime

// GTM Code Data Layer
declare global {
  interface Window {
    dataLayer: any[];
  }
}
window.dataLayer = window.dataLayer || [];
// GTM Code Data Layer

import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule, createApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgxExtendedPdfViewerModule, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

import { AppComponent } from './app/app.component';
import { TokenInterceptor } from './app/interceptors/TokenInterceptor';
import { assetUrl } from './app/asset-url';
import { BootstrapService } from './app/core/bootstrap/bootstrap.service';
import { ActivityDocumentsComponent } from './app/pages/activity-documents/activity-documents.component';
import { PolicyDocumentsComponent } from './app/pages/policy-documents/policy-documents.component';
import { PostsComponent } from './app/pages/posts/posts.component';
import { AlertsComponent } from './app/pages/alerts/alerts.component';
import { SummaryComponent } from './app/pages/summary/summary.component';
import { SharedPostsComponent } from './app/shared/components/shared-posts/shared-posts.component';
import { SharedCollaborationSummaryComponent } from './app/shared/components/shared-collaboration-summary/shared-collaboration-summary.component';

// Point ngx-extended-pdf-viewer at the MFE's actual asset path BEFORE any viewer instance
// is created. __webpack_public_path__ is set at runtime by ./set-public-path (imported first
// above), so assetUrl() returns the right origin regardless of where the bundle is served.
pdfDefaultOptions.assetsFolder = assetUrl('').replace(/\/$/, '');
// eslint-disable-next-line no-console
console.log('[pdf-renderer] assetsFolder =', pdfDefaultOptions.assetsFolder);

// Angular Elements custom-element registration must not depend on the app-root-component
// selector being present in the host page — the shell only embeds the exp-* tags below, not
// app-root-component. createApplication() builds the DI environment without requiring a root
// component match, so custom-element registration always runs; mounting AppComponent onto
// app-root-component (only present when this app is loaded standalone) is attempted afterward
// and independently, matching the original AppModule-constructor-based behavior.
createApplication({
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter([
            { path: '', component: AppComponent },
            { path: '**', redirectTo: '' }
        ]),
        importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule, MatTabsModule, MatTableModule, MatMenuModule, MatButtonModule, MatIconModule, MatDialogModule, MatTooltipModule, MatFormFieldModule, MatInputModule, MatProgressBarModule, MatProgressSpinnerModule, MatSnackBarModule, NgxDocViewerModule, MatCardModule, MatChipsModule, MatSidenavModule, MatSlideToggleModule, InfiniteScrollDirective, NgxExtendedPdfViewerModule),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideAnimations()
    ]
})
  .then((appRef) => {
    const injector = appRef.injector;
    const bootstrapService = injector.get(BootstrapService);
    [
      { tag: 'exp-activity-documents', component: ActivityDocumentsComponent },
      { tag: 'exp-policy-documents', component: PolicyDocumentsComponent },
      { tag: 'exp-posts', component: PostsComponent },
      { tag: 'exp-alerts', component: AlertsComponent },
      { tag: 'exp-collaboration', component: SummaryComponent },
      { tag: 'exp-shared-posts', component: SharedPostsComponent },
      { tag: 'exp-shared-collaboration-summary', component: SharedCollaborationSummaryComponent },
    ].forEach(({ tag, component }) => bootstrapService.add({ tag, component, injector }));
    bootstrapService.start();

    appRef.bootstrap(AppComponent, 'app-root-component');
  })
  .catch(err => console.error(err));
